// Sdílený zdroj „našeptaných dotazů" (issue #31, screens/17-vyhledavani.md).
//
// Shoptet nevystavuje ani log vyhledávání, ani fulltextové návrhy dotazů —
// nativní našeptávač umí jen produkty / kategorie / značky. Levý sloupec
// desktopového panelu a chipy prázdného stavu proto jedou z ručního seznamu
// z designu; reálná data (statistiky hledání z administrace) sem patří po
// go-live (QA sweep, issue #41).
//
// Degradace dle specky: když dotazu neodpovídá žádný návrh, blok se nevykreslí.

import { page } from './pages.js';
import L from '../locale/cs/searchSuggest.js';

// Pořadí z mockupu Vyhledávání.dc.html (`popular`).
export const POPULAR = L.popular;

// „Křovinořez" == „krovinorez" — diakritiku i velikost písmen ignorujeme,
// ať našeptávač funguje i bez české klávesnice.
function fold(s) {
  return (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

// Návrhy k dotazu: [{ query, hit, rest }] — `hit` je shodná část (kreslí se 800),
// `rest` doplněk. Nejdřív návrhy začínající dotazem, pak ty, co ho obsahují.
export function suggestQueries(q, limit) {
  const needle = fold(q);
  if (!needle) return [];
  const max = limit || 5;
  const starts = [];
  const contains = [];

  POPULAR.forEach(function (item) {
    const hay = fold(item);
    const at = hay.indexOf(needle);
    if (at === -1) return;
    if (hay === needle) return; // přesná shoda = to, co uživatel právě píše
    const entry = { query: item, hit: item.slice(0, at + needle.length), rest: item.slice(at + needle.length) };
    (at === 0 ? starts : contains).push(entry);
  });

  return starts.concat(contains).slice(0, max);
}

export function searchUrl(q) {
  return page('search') + '?string=' + encodeURIComponent(q);
}

// Dotaz aktuální stránky výsledků: URL má přednost (nativní pole ho sice nese,
// ale sheet a našeptávač do něj píšou), fallback je nativní nadpis výsledků.
export function currentQuery() {
  try {
    const q = new URL(window.location.href).searchParams.get('string');
    if (q) return q.trim();
  } catch (e) {
    /* starý prohlížeč bez URL API */
  }
  const input = document.querySelector('#header .query-input');
  if (input && input.value) return input.value.trim();
  const native = document.querySelector('#content h2 .highlight');
  return native ? (native.textContent || '').replace(/["„“]/g, '').trim() : '';
}
